// api
let api, apiStandard24, passportUrl, wifiEnUrl, bannerConfigUrl, wifiJSPCUrl, wifiNationPCUrl, JiProtryUrl, staticBaseUrl, newMgmBaseUrl, finderAppid, frontConf, CEM_PC_SCTRIP, CEM_C_SCTRIP, CEM_moduleCode, CEM_strategyId, hotelImgConfUrl, accorUrl, previewHost;

if (process.env.REACT_APP_ENV === 'production') {
  // 生产环境
  api = 'https://portalapi.huazhu.com';
  apiStandard24 = 'https://dservice-portal.huazhu.com';
  wifiEnUrl = 'https://haowifi.huazhu.com/enlogin.html';
  bannerConfigUrl = api + '/api/handle/bannerConfig?activityId=commonLogoWallConfig';
  wifiJSPCUrl = 'https://haowifi.huazhu.com/pchomejiangsu.html?param=';
  wifiNationPCUrl = 'https://haowifi.huazhu.com/pchome.html?param=';
  JiProtryUrl = 'https://quanjipoem.huazhu.com/entry/';
  staticBaseUrl = 'https://campaign.huazhu.com/static/2019';
  newMgmBaseUrl = 'https://newmgm.huazhu.com'; // 赠卡页
  frontConf = 'https://res-pub.huazhu.com/cossixhs/portal/PortalFrontendConfig.json';
  CEM_PC_SCTRIP = 'https://cdn.huazhu.com/cem-feedback/feedbackScript.js';
  CEM_C_SCTRIP = 'https://res-pub.huazhu.com/cossixhs/cemfeedback/c-script.js';
  CEM_moduleCode = 'DDTYDDTYDDZZKFFWWI-FI';
  CEM_strategyId = 5;
  finderAppid = 10000042;
  hotelImgConfUrl = 'https://res-pub.huazhu.com/cossixhs/portal/hotelImgConfUrl.json';
  accorUrl = 'https://h5.accor.cn/huazhu/enroll';
  previewHost = 'pre-haoportal.huazhu.com'
} else if (process.env.REACT_APP_ENV === 'preview') {
  // 预发布环境
  // api = 'https://portalapi.huazhu.com:8443';
  api = 'https://portalapi.huazhu.com';
  apiStandard24 = 'https://dservice-portal.huazhu.com';
  wifiEnUrl = 'https://haowifi.huazhu.com/enlogin.html';
  bannerConfigUrl = api + '/api/handle/bannerConfig?activityId=commonLogoWallConfig';
  wifiJSPCUrl = 'https://haowifi.huazhu.com/pchomejiangsu.html?param=';
  wifiNationPCUrl = 'https://haowifi.huazhu.com/pchome.html?param=';
  JiProtryUrl = 'https://quanjipoem.huazhu.com/entry/';
  staticBaseUrl = 'https://campaign.huazhu.com/static/preview';
  newMgmBaseUrl = 'https://newmgm.huazhu.com'; // 赠卡页
  frontConf = 'https://res-pub.huazhu.com/cossixhs/portal/PortalFrontendConfig.json';
  finderAppid = 10000042;
  CEM_PC_SCTRIP = 'https://cdn.huazhu.com/cem-feedback/feedbackScript.js';
  CEM_C_SCTRIP = 'https://res-pub.huazhu.com/cossixhs/cemfeedback/c-script.js';
  CEM_moduleCode = 'DDTYDDTYDDZZKFFWWI-FI';
  CEM_strategyId = 5;
  hotelImgConfUrl = 'https://res-pub.huazhu.com/cossixhs/portal/hotelImgConfUrl.json';
  accorUrl = 'https://uat-h5.accor.cn/huazhu/enroll';
  previewHost = 'pre-haoportal.huazhu.com';
} else {
  let __TEST_API_DOMAIN = 'huazhu';
  if (window.location.host.indexOf('huazhucorp') > -1) {
    __TEST_API_DOMAIN = 'huazhucorp';
  }

  // api = 'http://10.106.89.35'; //开发环境
  api = `https://test-wifiapi.${__TEST_API_DOMAIN}.com`; //测试环境
  apiStandard24 = `https://test-dservice-portal.huazhucorp.com`; //测试环境
  // api = 'https://test-wifiapi.huazhu.com'; //测试环境
  // api = 'https://portalapi-preview.huazhu.com';//预生产环境
  // api = 'http://10.105.242.98:30008'; //本地
  // api = 'http://10.106.89.28:30008'; //思源本地
  // api = 'http://10.106.89.35:30008/'; //孙闯本地
  // api = 'http://10.106.89.228:30008/'; //廖磊本地
  wifiEnUrl = 'https://test-haowifi.huazhu.com/enlogin.html';
  bannerConfigUrl = api + '/api/handle/bannerConfig?activityId=commonLogoWallConfig';
  wifiJSPCUrl = 'https://test-haowifi.huazhu.com/pchomejiangsu.html?param=';
  wifiNationPCUrl = 'https://test-haowifi.huazhu.com/pchome.html?param=';
  JiProtryUrl = 'https://test-quanjipoem.huazhucorp.com/entry/';
  staticBaseUrl = 'https://test-campaign.huazhu.com'; // 静态资源站
  newMgmBaseUrl = 'https://test-newmgm.huazhucorp.com'; // 赠卡页
  frontConf = 'https://res-pub.huazhu.com/cossixhs/portal/PortalFrontendConfigTest.json';
  finderAppid = 10000041;
  CEM_PC_SCTRIP = 'https://test-cdn.huazhucorp.com/cem-feedback/feedbackScript.js';
  CEM_C_SCTRIP = 'https://res-pub.huazhu.com/cossixhs/cemfeedback/c-script-test.js';
  CEM_moduleCode = 'DDTYDDTYDDZQFWWI-FI PORT';
  CEM_strategyId = 169;
  hotelImgConfUrl = 'https://res-pub.huazhu.com/cossixhs/portal/hotelImgConfUrl.test.json';
  accorUrl = 'https://uat-h5.accor.cn/huazhu/enroll';
  previewHost = 'test-pre-haoportal.huazhucorp.com';
}

export { api, apiStandard24, passportUrl, wifiEnUrl, bannerConfigUrl, wifiJSPCUrl, wifiNationPCUrl, JiProtryUrl, staticBaseUrl, newMgmBaseUrl, finderAppid, frontConf, CEM_PC_SCTRIP, CEM_C_SCTRIP, CEM_moduleCode, CEM_strategyId, hotelImgConfUrl, accorUrl, previewHost };
